<app-soft-deletable-auditable-entities
  [paginationResponseResolver]="paginationResponseResolver()"
  [defaultPaginationParameters]="defaultPaginationParameters()"
  [supportedActions]="supportedActions()"
  [tableConfig]="finalTableConfig()"
  (actionExecuted)="onActionExecuted($event)"
/>

<ng-template #tableRowTemplate let-element>
  <td>{{ element.englishName }}</td>
  <ng-container *ngIf="tableConfig()?.template; else defaultTemplate">
    <ng-container *ngTemplateOutlet="tableConfig()!.template; context: { $implicit: element }"></ng-container>
  </ng-container>
  <ng-template #defaultTemplate let-element></ng-template>
</ng-template>
